import React from 'react';
import PropTypes from 'prop-types';
import { ForgeCountCard } from '@tylertech/forge-extended-react';
import '../AiAnalytics.scss';
import { AI_ANALYTICS_SLOTS } from '../aiAnalyticsHelpers.js';

const StatsRow = ({data}) => {
  return (
    <div className="cardsRow">
      {
        data?.map((cardData, ind) => {
          return (
            <ForgeCountCard key={ind}>
              <span slot={AI_ANALYTICS_SLOTS.LABEL}>{cardData.label}</span>
              <span slot={AI_ANALYTICS_SLOTS.COUNT}>{cardData.count}</span>
            </ForgeCountCard>
          );
        })
      }
    </div>
  );
};

export default StatsRow;

StatsRow.propTypes = {
  data: PropTypes.array,
};
